import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

export default class FailInitialize extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
				dummy: 0
		}
	}

	render() {
		return (
			<div className="main l-margin-y--xxl announc--studio">
				<div className="main__content l-pad--null border-color--pewter">
					{this.renderHeader()}
					{this.renderContent()}
				</div>
			</div>
		);
	}

	renderHeader() {
		return (
			<div className="announc__head">
				<h1 className="announc__head-title">"Failed to Initialize" Issue in Studio</h1>
				<p className="announc__head-sub-title l-margin-bottom--null">We apologize for the experience and are working hard to resolve the issue. However, it would take some time to completely terminate the bug because there are many things that are causing this issue. Recommendations for resolution are below. If you are still having problems, please contact us at <a href="mailto:studio@bricklink.com" className="text-color--white text--underline">studio@bricklink.com</a>!</p>
			</div>
		);
	}

	renderContent() {
		return (
			<section className="announc__studio-body">
				<h2 className="section-title l-margin-bottom">Recommended actions</h2>
				<ol className="number-list announc__studio-list">
					<li><strong>Launch Studio with "Run as Administrator" option</strong></li>
					<li>
						<strong>Update your graphic card drivers to the latest version</strong>
						<ul className="bullet-list">
							<li>If you experience a black blank screen when launching Studio, try changing the display Go to AMD Radeon settings and under "display," change scaling mode from "preserve aspect ratio" to "full panel" OR,</li>
							<li>Launch the app with the integrated graphics card if you happen to have multiple graphic card drivers.</li>
						</ul>
					</li>
					<li>
						<strong>Start the troubleshooting process in Studio app..</strong>
						<ul className="bullet-list">
							<li>
								<p>When the system detects the failed to initialize issue, it will display a pop-up to let you start the troubleshooting process. As this case is mostly caused by the Studio cache folder, the troubleshooting process is to delete the folder and create a new one. To keep you from losing any custom parts or palette data, this process includes a backup process of the folder.</p>
							</li>
							<li>
								<p>Clicking on "Troubleshoot" will give you an explanation of the process. </p>
							</li>
							<li>
								<p>Clicking on the “Proceed” button will begin the troubleshooting process. </p>
							</li>
							<li>
								<p className="l-margin-bottom--xs">After the process is complete, you should be able to find the backup folder below.</p>
								<p className="l-margin-bottom--xs"><strong>Mac:</strong> Users > YOUR USERNAME > .local > share > Stud.io Backup</p>
								<p className="l-margin-bottom--xs">Note: to see the hidden folders in your user folder(.local), press <strong>Shift + Cmd + ></strong>.</p>
								<p><strong>Windows:</strong> Find the file under {"\\Users\\{UserName}\\AppData\\Local\\Stud.io Backup"}</p>
							</li>
						</ul>
					</li>
				</ol>
				<div className="announc__studio-footer">
					<strong>I've tried the above, but the issue still hasn’t been resolved. What do I do?</strong>
					<ul className="bullet-list l-margin-bottom--sm">
						<li>Please send us an error log file (Prev_Player.log), which can be found in the same location as the cache file, and include your computer specs and OS information.</li>
					</ul>
					<strong>I’ve encountered the "unable to install Studio on my Mac" issue.</strong>
					<ul className="bullet-list">
						<li>If you encounter the message saying, “Studio.pkg cannot be opened because Apple cannot check it for malicious software," try to launch the .pkg file while pressing Ctrl, or you can right click it and select Open. If you wish to know more information about this issue, please refer to the <a href="https://support.apple.com/guide/mac-help/open-a-mac-app-from-an-unidentified-developer-mh40616/mac" target="_blank">Mac OS User Guide</a>.</li>
					</ul>
				</div>
			</section>
		);
	}
	
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<FailInitialize blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);
